import { useGlobalFeatureControl } from "../contexts/FeatureControlContext/FeatureControlContext";
import { FeatureControl } from "../contexts/FeatureControlContext/types";

type VersionComponent = {
  fcKey: string;
  log?: string;
  EnabledComponent: Element;
};

type Props = {
  enableLog?: boolean;
  versionComponents: VersionComponent[];
  DisabledComponent: Element;
};

export default function FeatureControlVersioning(props: Props) {
  const { enableLog = false, versionComponents, DisabledComponent } = props;

  const featureControls = useGlobalFeatureControl();
  const renderedComponent = findRenderedComponent(
    featureControls,
    versionComponents
  );
  if (renderedComponent) {
    const { fcKey, log, EnabledComponent } = renderedComponent;
    if (enableLog) {
      console.log(
        `FeatureControlVersioning: ${fcKey} is enabled. Log: ${log ?? "-"}`
      );
    }
    return EnabledComponent;
  }

  // Using the last version key and log to show that no feature control is enabled
  if (enableLog) {
    const lastVersionComponent =
      versionComponents[versionComponents.length - 1];
    console.log(
      `FeatureControlVersioning: No feature control is enabled (${
        lastVersionComponent.fcKey
      }). Log: ${lastVersionComponent.log ?? "-"}`
    );
  }
  return DisabledComponent;
}

function findRenderedComponent(
  featureControls: FeatureControl,
  versionComponents: VersionComponent[]
) {
  for (let i = versionComponents.length - 1; i >= 0; i--) {
    const { fcKey } = versionComponents[i];
    const fc = featureControls[fcKey];
    if (fc && fc.enabled) {
      return versionComponents[i];
    }
  }
}
